import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/shape-9.png'


const _hoisted_1 = { class: "container mw-1356" }
const _hoisted_2 = {
  class: "services-test-content",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_3 = { class: "d-flex gap-2 flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: "services-test-area bg-mg ptb-100 position-relative overflow-hidden",
    style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.bgImage + ')' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createStaticVNode("<span class=\"top-title\">التجربة</span><h2 class=\"text-white\"> ابدأ الآن. لا تتردد في تجربة خدمتنا </h2><p class=\"text-silver\"> حساب تجريبي. احصل على وصول كامل لجميع القنوات ومكتبة الأفلام والمسلسلات </p><div class=\"d-flex align-items-center amount\"><div class=\"flex-shrink-0\"><i class=\"flaticon-tv\"></i></div><div class=\"flex-grow-1 ms-3\"><h2>$ 14.99<sub>/ شهرياً</sub></h2><span>تجربة لمدة شهر واحد، الرضا مضمون أو استرداد أموالك.</span></div></div>", 4)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_RouterLink, {
            to: "/services",
            class: "btn bg-grey-teal"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "border-style" }, "جرب خدمتنا الآن", -1)
            ]))]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createElementVNode("a", {
            href: "tel:3212344567",
            class: "btn bg-transparent"
          }, [
            _createElementVNode("span", { class: "border-style" }, [
              _createElementVNode("span", null, "اتصل: 3212344567+"),
              _createTextVNode(" لأي استفسار ")
            ])
          ], -1))
        ])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("img", {
      src: _imports_0,
      class: "shape shape-9",
      alt: "shape"
    }, null, -1))
  ], 4))
}